import React from 'react'
import _get from 'lodash/get'
import FormsyForm from 'formsy-react'
import { useSelector } from 'react-redux'
import { List, Map } from 'immutable'
import Sherpa, { TYPE_LARGE } from '../../Sherpa/index'
import { TextInput } from '../../FormInput.v2/index'
import { selectGiftPlanByPlanId } from '../../../services/plans/selectors'
import { get as getConfig } from '../../../config/index'
import { useGetPlanDataBySku } from '../../../services/plans/hooks'
import Button, { TYPES } from '../../Button/index'
import { H4 } from '../../Heading/index'
import { selectGiftTokenError, selectGiftIsExpired } from '../../../services/gift/selectors'
import { selectAuth } from '../../../services/auth/selectors'
import { selectPrimaryLanguage } from '../../../services/user/selectors'
import PlanValueProp from '../../PlanValueProp/index'

const config = getConfig()
const planGraphQLActive = !!_get(config, ['features', 'checkout', 'planGraphQL'])

function GreetingGraphQL (props) {
  const {
    translate,
    gift,
    auth,
    userLanguage,
  } = props
  const planSku = gift.get('planSku')
  let giftPlan = List()
  if (planSku) {
    const gqlPlanData = useGetPlanDataBySku({
      userLanguage,
      authJwt: auth.get('jwt'),
      planSkus: planSku,
    }) || Map()
    giftPlan = gqlPlanData.get('plans', List()) || List()
  }

  const gifterName = gift.get('gifterName')
  const planName = giftPlan.getIn([0, 'name'])
  const message = gift.get('message')
  const valueProps = giftPlan && giftPlan.getIn([0, 'valueProps'], List())

  if (!giftPlan || !giftPlan.size) {
    return (
      <div className="gift-redeem__sherpa">
        <Sherpa type={TYPE_LARGE} />
        <span>{translate('messageLoading')}</span>
      </div>
    )
  }

  return (
    <div className="gift-redeem__greeting">
      <div className="gift-redeem__greeting-from">
        { gifterName && <H4>{translate('greetingTitleFrom', { gifterName })}</H4>}
        { message && <p>{message}</p>}
      </div>
      <div className="gift-redeem__greeting-plan">
        { planName && <H4>{translate('greetingTitlePlan', { planName })}</H4>}
      </div>
      <ul className="gift-redeem__value-list">
        {valueProps.map((vp, index) => {
          return (
            <li
              className="gift-redeem__value-list-item"
              key={`gift-redeem-value-prop-${index}`}
            >
              <PlanValueProp valueProp={vp} className="gift-redeem__value-list-item-text" />
            </li>
          )
        })}
      </ul>
    </div>
  )
}

function GiftSectionGreeting (props) {
  const {
    onTokenEntered,
    formatDate,
    translate,
    gift,
  } = props
  const auth = useSelector(selectAuth)
  const userLanguage = useSelector(selectPrimaryLanguage)
  const planId = gift.get('planId')
  const plan = useSelector(selectGiftPlanByPlanId(planId))
  const giftTokenError = useSelector(selectGiftTokenError)
  const processing = !!gift.get('processing')
  const hasBeenRedeemed = !!gift.get('redeemedAt')
  const isExpired = useSelector(selectGiftIsExpired)

  if (!planGraphQLActive && (processing || (!giftTokenError && !plan))) {
    return (
      <div className="gift-redeem__sherpa">
        <Sherpa type={TYPE_LARGE} />
        <span>{translate('messageLoading')}</span>
      </div>
    )
  }

  if (planGraphQLActive && (processing || !gift.size)) {
    return (
      <div className="gift-redeem__sherpa">
        <Sherpa type={TYPE_LARGE} />
        <span>{translate('messageLoading')}</span>
      </div>
    )
  }

  if (isExpired) {
    const expiresAtFormatted = formatDate(
      gift.get('expiresAt'),
    )
    return (
      <div>
        <H4>{translate('messageTitleExpired')}</H4>
        <p>{translate('messageExpired', { expiresAtFormatted })}</p>
      </div>
    )
  }

  if (hasBeenRedeemed) {
    const redeemedAt = formatDate(
      gift.get('redeemedAt'),
    )
    return (
      <div>
        <H4>{translate('messageTitleRedeemed')}</H4>
        <p>{translate('messageRedeemed', { redeemedAt })}</p>
      </div>
    )
  }

  if (!planGraphQLActive && gift.get('token') && plan) {
    const gifterName = gift.get('gifterName')
    const planName = plan.get('name')
    const message = gift.get('message')
    const valueProps = plan && plan.get('valueProps', List())
    return (
      <div className="gift-redeem__greeting">
        <div className="gift-redeem__greeting-from">
          { gifterName && <H4>{translate('greetingTitleFrom', { gifterName })}</H4>}
          { message && <p>{message}</p>}
        </div>
        <div className="gift-redeem__greeting-plan">
          { planName && <H4>{translate('greetingTitlePlan', { planName })}</H4>}
        </div>
        <ul className="gift-redeem__value-list">
          {valueProps.map((vp, index) => {
            return (
              <li
                className="gift-redeem__value-list-item"
                key={`gift-redeem-value-prop-${index}`}
              >
                <PlanValueProp valueProp={vp} className="gift-redeem__value-list-item-text" />
              </li>
            )
          })}
        </ul>
      </div>
    )
  }

  if (planGraphQLActive && gift.get('token')) {
    return (
      <GreetingGraphQL {...props} auth={auth} userLanguage={userLanguage} />
    )
  }

  return (
    <div className="gift-redeem__token">
      <p>{translate('noToken')}</p>
      <FormsyForm onValidSubmit={onTokenEntered}>
        <TextInput
          label={translate('greetingGiftCode')}
          placeholder="xX1yY2zZ3"
          name="token"
          value=""
        />
        <Button
          type={TYPES.PRIMARY}
          submit
        >{translate('redeemCTA')}
        </Button>
      </FormsyForm>
    </div>
  )
}

export default GiftSectionGreeting
